import React, { useState } from 'react';
import { Form } from 'react-bootstrap';
import TextInputWithLabel from '../TextInputWithLabel';
import MultiSelect from '../MultiSelect';
import SButton from '../Button';
import SelectBox from '../SelectBox';
import DatePicker from 'react-flatpickr';
import InputWithSuggest from '../InputWithSuggest';

function ModalForm({show,
    handleClose, 
    data, 
    formDatas,
    handleSave,
    title,
    label,
    btnLabel,
    loading
}) {
    const [isSaving, setIsSaving] = useState(false);
    const [errors, setErrors] = useState({});
    const [formData, setFormData] = useState(() =>
        formDatas.reduce((acc, field) => {
            let val = data?.[field.name];
            if (val === undefined) val = field.value;
            if (val === null) val = field.value;
            if (val === undefined) val = '';
            return { ...acc, [field.name]: val };
        }, {})
    );
    const [suggestions, setSuggestions] = useState([]);
    const [loadingSuggest, setLoadingSuggest] = useState(false);

    if(loading) {
        return (
            <div className='modal modal-lg fade show d-block' style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }} onClick={handleClose}>
                <div className='modal-dialog modal-dialog-centered' onClick={e => e.stopPropagation()} >
                    <div className='modal-content'>
                        <div className='modal-header'>
                            <h5 className="modal-title">{title}</h5>
                            <SButton variant={''} className={"btn-close"} action={handleClose} />     
                        </div>
                        <div className='modal-body d-flex justify-content-center align-items-center' style={{minHeight: '200px'}}>
                            <div className="spinner-border text-primary" role="status" style={{width: '3rem', height: '3rem'}}>
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }   

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));

        // Menghapus error saat input diubah
        if (errors[name]) {
            setErrors((prev) => ({ ...prev, [name]: null }));
        }
    };

    const handleSelectChange = (name, selectedOptions) => {
        setFormData((prev) => ({
            ...prev,
            [name]: selectedOptions.value,
        }));

        // Menghapus error saat input diubah
        if (errors[name]) {
            setErrors((prev) => ({ ...prev, [name]: null }));
        }
    };

    const handleMultiSelectChange = (name, selectedOptions) => {
        setFormData((prev) => ({
            ...prev,
            [name]: selectedOptions.map((option) => ({value: option.value,label: option.label})),
        }));

        if (errors[name]) {
            setErrors((prev) => ({
                ...prev,
                [name]: null,
            }));
        }
    };

    const validateForm = () => {
        let validationErrors = {};
        for (let field of formDatas) {
            const value = formData[field.name];
            if (field.required) {
                if (field.type === 'multiselect' && (!Array.isArray(value) || value.length === 0)) {
                    validationErrors[field.name] = `Field "${field.label}" is required.`;
                } else if (field.type === 'select' && (value === null || value === undefined || value === '')) {
                    validationErrors[field.name] = `Field "${field.label}" is required.`;
                } else if(field.type === 'datepicker' && !value) {
                    
                }else if (field.type === 'number' && (value === null || value === undefined || value === '')) {
                    validationErrors[field.name] = `Field "${field.label}" must be a valid number.`;
                }else if (field.type === 'text' && (value === null || value === undefined || value === '')) {
                    validationErrors[field.name] = `Field "${field.label}" is required.`;
                }else if( field.type === 'date' && !value ) {
                    
                }
            }
            // Validasi email
            if (field.type === 'text' && field.name === 'email' && value) {
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!emailRegex.test(value)) {
                    validationErrors[field.name] = 'Format email not valid.';
                }
            }
        }
        setErrors(validationErrors); 
        return Object.keys(validationErrors).length === 0;
    };


    const handleSubmit = (e) => {
        e.preventDefault();
        const validationError = validateForm();
        if (!validationError) return;

        setIsSaving(true);
        const updatedData = { ...formData };       

        try {
            handleSave(updatedData,formData)
            handleClose();
        } catch (error) {
            console.error('Error during save', error);
        } finally {
            setIsSaving(false);
        }
        
    };
    
    const handleOnlyNumberInput = (e) => {
        const charCode = e.which ? e.which : e.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            e.preventDefault();
        }
    };

    return (
        <>
            <div className='modal modal-lg fade show d-block' style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }} onClick={handleClose}>
                <div className='modal-dialog modal-dialog-centered' onClick={e => e.stopPropagation()} >
                    <div className='modal-content'>
                        <div className='modal-header'>
                            <h5 className="modal-title">{title}</h5>
                            <SButton variant={''} className={"btn-close"} action={handleClose} />     
                        </div>
                        <div className='modal-body'>
                             <Form onSubmit={handleSubmit}>
                                <div className="row">
                                {formDatas.map((field, index) => {
                                    let hasError = errors[field.name];
                                    switch (field.type) {
                                        case 'multiselect':
                                            let formattedValue;
                                            formattedValue = Array.isArray(formData[field.name])
                                                    ? formData[field.name].map((v) => ({ value: v.value || v, label: (v.label ? v.label : v.value)   || v })) // Ubah ke array objek
                                                    : formData[field.name] ? [{ value: formData[field.name], label: formData[field.name] }] : []; // Jika null, kosongkan

                                            return (
                                                <div key={index} className={field.column}>
                                                <MultiSelect
                                                    key={index}
                                                    id={`input-${index}`}
                                                    name={field.name}
                                                    label={field.label}
                                                    value={formattedValue}
                                                    classLabel={field.classLabel}
                                                    options={field.options}
                                                    handleChange={(selectedOptions) => handleMultiSelectChange(field.name, selectedOptions)}
                                                    style={{
                                                        borderColor: hasError ? 'red' : '',
                                                    }}
                                                />
                                                <label style={{color:'red'}}>{hasError}</label>
                                                </div>
                                            );
                                        case 'text' :
                                        case 'number' :
                                        case 'date' :
                                        case 'time' :
                                            return (
                                                <div key={index} className={field.column}>
                                                <TextInputWithLabel
                                                    key={index}
                                                    id={`input-${index}`}
                                                    label={field.label}
                                                    labelClass={field.classLabel}
                                                    name={field.name}
                                                    value={
                                                        field.type === 'date' && formData[field.name] 
                                                        ? new Date(formData[field.name]).toISOString().slice(0, 10)
                                                        : field.type === 'number' ? (formData[field.name] === 0 ? 0 : formData[field.name] || '') : formData[field.name] || ''
                                                    }
                                                    type={field.type || 'text'}
                                                    placeholder={field.placeholder || ''}
                                                    onChange={(e) => handleInputChange(e, field.name)}
                                                    onFocus={() => setErrors((prev) => ({ ...prev, [field.name]: null }))}
                                                    style={{
                                                        borderColor: hasError ? 'red' : '',
                                                    }}
                                                    disabled={field.disable}
                                                    onKeyDown={field.onlyNumber ? handleOnlyNumberInput : undefined}
                                                    required={field.required || false}
                                                />
                                                <label style={{color:'red'}}>{hasError}</label>
                                                </div>
                                            );
                                        case 'select':
                                            let selectVal;
                                            selectVal = formData[field.name] && typeof formData[field.name] === 'object'
                                                ? formData[field.name] // Jika sudah objek { value, label }
                                                : field.options.find(opt => opt.value === formData[field.name]) || { value: formData[field.name], label: `Select a ${field.name}` };
                                            return (
                                                <div key={index} className={field.column}>
                                                <SelectBox
                                                    key={index}
                                                    id={`input-${index}`}
                                                    name={field.name}
                                                    options={field.options}
                                                    value={selectVal}
                                                    placeholder={field.placeholder || ''}
                                                    label={field.label}
                                                    style={{
                                                        borderColor: hasError ? 'red' : '',
                                                    }}
                                                    classLabel={field.classLabel}
                                                    required={field.required || false}
                                                    handleChange={(selectedOptions) => handleSelectChange(field.name, selectedOptions)}
                                                />
                                                 <label style={{color:'red'}}>{hasError}</label>
                                                </div>
                                            )
                                        case 'textarea':
                                            return (
                                                <div key={index} className={field.column}>
                                                <label className={field.classLabel} htmlFor={`input-${index}`}>{field.label}</label>
                                                {field.required && <span className='text-danger'>*</span>}
                                                <textarea 
                                                key={index}
                                                id={`input-${index}`}
                                                name={field.name}
                                                className={`form-control ${field.className || ''}`}
                                                placeholder={field.placeholder || ''}
                                                value={formData[field.name] || ''}
                                                onChange={handleInputChange}
                                                onFocus={() => setErrors((prev) => ({ ...prev, [field.name]: null }))}
                                                style={{borderColor: hasError ? 'red' : ''}}
                                                disabled={field.disabled}
                                                rows={field.rows || 3}
                                                cols={field.cols || 50}
                                                maxLength={field.maxLength || 500}
                                                autoComplete={field.autoComplete || 'off'}
                                                autoFocus={field.autoFocus || false}
                                                onKeyDown={field.onlyNumber ? handleOnlyNumberInput : undefined}
                                                />
                                                <label style={{color:'red'}}>{hasError}</label>
                                                </div>
                                            );
                                        case 'datepicker':
                                            return (
                                                <div key={index} className={field.column}>
                                                    <label className={field.classLabel} htmlFor={`input-${index}`}>{field.label}</label>
                                                    <DatePicker
                                                        id={`input-${index}`}
                                                        name={field.name}
                                                        className={`form-control ${field.className || ''}`}
                                                        placeholder={field.placeholder || ''}
                                                        value={
                                                            formData[field.name]
                                                                ? new Date(formData[field.name])
                                                                : new Date()
                                                        }
                                                        onChange={(date) => handleInputChange({ target: { name: field.name, value: date[0] } })}
                                                        onFocus={() => setErrors((prev) => ({ ...prev, [field.name]: null }))}
                                                        style={{ borderColor: hasError ? 'red' : '' }}
                                                        disabled={field.disabled}
                                                        options={{
                                                            dateFormat: 'Y-m-d',
                                                            minDate: new Date(), // tidak bisa pilih tanggal sebelum hari ini
                                                        }}
                                                        autoComplete={field.autoComplete || 'off'}
                                                        autoFocus={field.autoFocus || false}
                                                    />
                                                    <label style={{color:'red'}}>{hasError}</label>
                                                </div>
                                            )
                                        case 'timepicker':
                                            return (
                                                <div key={index} className={field.column}>
                                                    <label className={field.classLabel} htmlFor={`input-${index}`}>{field.label}</label>
                                                    <DatePicker
                                                        id={`input-${index}`}
                                                        name={field.name}
                                                        className={`form-control ${field.className || ''}`}
                                                        placeholder={field.placeholder || ''}
                                                        value={
                                                            formData[field.name]
                                                                ? formData[field.name] // pastikan value sudah dalam format 'HH:mm'
                                                                : new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false }) // default ke jam sekarang
                                                        }
                                                        onChange={(date) => {
                                                            // date[0] adalah objek Date, ambil jam dan menitnya saja
                                                            const timeValue = date[0]
                                                                ? date[0].toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false })
                                                                : '';
                                                            handleInputChange({ target: { name: field.name, value: timeValue } });
                                                        }}
                                                        onFocus={() => setErrors((prev) => ({ ...prev, [field.name]: null }))}
                                                        style={{ borderColor: hasError ? 'red' : '' }}
                                                        disabled={field.disabled}
                                                        options={{
                                                            enableTime: true,
                                                            noCalendar: true,
                                                            dateFormat: 'H:i',
                                                            time_24hr: true,
                                                            defaultDate: new Date(), // default jam sekarang
                                                        }}
                                                        autoComplete={field.autoComplete || 'off'}
                                                        autoFocus={field.autoFocus || false}
                                                    />
                                                    <label style={{color:'red'}}>{hasError}</label>
                                                </div>
                                            )
                                        case 'radio':
                                            return (
                                                <div key={index} className={field.column}>
                                                    <label className={field.classLabel}>{field.label}</label>
                                                    <div className="d-flex gap-3 mt-2">
                                                        {field.options.map((option, idx) => (
                                                            <div key={idx} className="form-check">
                                                                <input
                                                                    type="radio"
                                                                    className="form-check-input"
                                                                    id={`${field.name}-${idx}`}
                                                                    name={field.name}
                                                                    value={option.value}
                                                                    checked={formData[field.name] === option.value}
                                                                    onChange={(e) => handleInputChange({ target: { name: field.name, value: option.value } })}
                                                                    disabled={field.disabled}
                                                                    
                                                                />
                                                                <label className="form-check-label" htmlFor={`${field.name}-${idx}`}>
                                                                    {option.label}
                                                                </label>
                                                            </div>
                                                        ))}
                                                    </div>
                                                    <label style={{color:'red'}}>{hasError}</label>
                                                </div>
                                            )
                                        case 'autocomplete':
                                            return (
                                                <div key={index} className={field.column}>
                                                    <InputWithSuggest
                                                        label={field.label}
                                                        name={field.name}
                                                        value={formData[field.name] || ''}
                                                        type="text"
                                                        placeholder={field.placeholder || ''}
                                                        onFocus={e => {
                                                            // Reset suggestions saat input pertama kali di klik
                                                            setSuggestions([]);
                                                        }}
                                                        onChange={e => {
                                                            const inputValue = e.target.value;
                                                            setFormData(prev => ({ ...prev, [field.name]: inputValue }));
                                                            setErrors(prev => ({ ...prev, [field.name]: null }));
                                                            setLoadingSuggest(true);
                                                            if (field.data && Array.isArray(field.data)) {
                                                                setTimeout(() => {
                                                                    if (inputValue.trim() === '') {
                                                                        setSuggestions([]);
                                                                        setLoadingSuggest(false);
                                                                        return;
                                                                    }
                                                                    const filtered = field.data.filter(item =>
                                                                        (item.full_name || '').toLowerCase().includes(inputValue.toLowerCase())
                                                                    );
                                                                    setSuggestions(filtered);
                                                                    setLoadingSuggest(false);
                                                                }, 400); // simulasi loading
                                                            } else {
                                                                setLoadingSuggest(false);
                                                            }
                                                        }}
                                                        loading={loadingSuggest}
                                                        suggestions={suggestions}
                                                        map={suggestions.map((item, idx) => (
                                                            <li key={idx} style={{cursor: 'pointer', padding: 8}} onClick={() => {
                                                                setFormData(prev => ({
                                                                    ...prev,
                                                                    [field.name]: item.full_name || '',
                                                                    no_medical_record: item.no_medical_record || '',
                                                                    handphone: item.phone_number || '',
                                                                    email: item.email || ''
                                                                }));
                                                                setSuggestions([]);
                                                            }}>
                                                                {item.full_name || ''}-{item.no_medical_record || ''}
                                                            </li>
                                                        ))}
                                                    />
                                                    <label style={{color:'red'}}>{hasError}</label>
                                                </div>
                                            );
                                        default:
                                            return null; // Menghindari warn jika tidak ada return pada default
                                    }
                                    
                                })}
                                </div>
                                <div className="d-flex mt-5 justify-content-end">
                                    <SButton  action={handleClose}  variant={'secondary'} children={'Cancel'}>
                                        Cancel
                                    </SButton>
                                    <SButton type={'submit'} variant={'primary'} children={ isSaving ? 'Loading...' : 'Edit'} className={'ms-3'} disabled={isSaving}>
                                        {isSaving ? 'Loading...' : btnLabel || 'Save'}
                                    </SButton>
                                </div>
                            </Form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ModalForm;
